module.exports = __webpack_public_path__ + "img/blueBOOK.655a9731.svg";